const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const formatArticleDate = (iso) => {
  const [year, month, day] = iso.split('-');
  return `${Number(day)} ${MONTHS[Number(month) - 1]}, ${year}`;
};

const piece = (slug, title, date, lead, paragraphs, sections) => ({
  slug,
  title,
  date,
  lead,
  paragraphs,
  sections,
});

export const posts = [
  piece(
    'drawesome',
    'Drawesome',
    '2026-07-29',
    '',
    [
      'A drawing tool should get out of the way the moment the mark starts. Most of the work was deciding what not to put on screen. A pen, a color, and an undo are enough until the drawing asks for more.',
    ],
    []
  ),
  piece(
    'liveline',
    'Liveline',
    '2026-02-16',
    'A line is easier to follow when it moves with the thought, not after it.',
    [
      'This started as a way to keep a running note beside the work, instead of saving the explanation for the end.',
    ],
    [
      {
        id: 'the-line',
        title: 'The line',
        paragraphs: [
          'Each entry is one thread. It stays short so the next one can pick up without restating the whole thing.',
        ],
      },
      {
        id: 'along-the-way',
        title: 'Along the way',
        paragraphs: [
          'The useful bits were the ones written while the work was still open, not the summary written later.',
        ],
      },
      {
        id: 'what-it-leaves-out',
        title: 'What it leaves out',
        paragraphs: [
          'No status, no score, no extra panel. If a line does not change what happens next, it does not belong on the page.',
        ],
      },
    ]
  ),
  piece(
    'agentation',
    'Agentation',
    '2026-01-21',
    'Notes for an agent are only useful if a person can still read them.',
    [
      'The file had to work in two directions: enough structure for a model, and enough plain language that I could scan it later.',
    ],
    [
      {
        id: 'the-note',
        title: 'The note',
        paragraphs: [
          'Each note is a short claim, then the evidence under it. No headings for their own sake. If a line does not change what the agent does next, it comes out.',
        ],
      },
      {
        id: 'reading-it-back',
        title: 'Reading it back',
        paragraphs: [
          'I rewrote the notes as if I would open them in a month. The ones that still made sense without the chat around them were the ones worth keeping.',
        ],
      },
    ]
  ),
  piece(
    'annotating-for-agents',
    'Annotating for agents',
    '2026-01-16',
    'An annotation should point at the thing, not describe the whole screen.',
    [
      'I was marking up interfaces for an agent that could see the page. The useful marks were small: this control, this state, this mistake.',
    ],
    [
      {
        id: 'what-to-mark',
        title: 'What to mark',
        paragraphs: [
          'A box around a region is weaker than a note on the exact control. The agent already sees the layout. It needs the decision.',
        ],
      },
      {
        id: 'how-it-reads',
        title: 'How it reads',
        paragraphs: [
          'The same note has to make sense if a person opens it. A label, a target, and one sentence. Anything longer starts to rot.',
        ],
      },
    ]
  ),
  piece(
    'morphing-icons-with-claude',
    'Morphing icons with Claude',
    '2026-01-13',
    'An icon that morphs should still be recognizable at both ends of the motion.',
    [
      'I used Claude to try shapes, then kept the ones I could read at a glance. The motion is the easy part. The two silhouettes are the work.',
    ],
    [
      {
        id: 'two-shapes',
        title: 'Two shapes',
        paragraphs: [
          'Each icon is a pair. If the start and the end do not share a stroke, the morph looks like a swap instead of a change.',
        ],
      },
      {
        id: 'the-in-between',
        title: 'The in-between',
        paragraphs: [
          'The middle frames are where it usually breaks. I checked those more than the endpoints. A pretty start and end can still pass through a mess.',
        ],
      },
    ]
  ),
  piece(
    'honkish',
    'Honkish',
    '2025-05-23',
    'A small sound can carry a whole interface if it only plays when something actually happened.',
    [
      'Honkish started as a joke and stayed because the timing was right. The sound marks a completion, not a click.',
    ],
    [
      {
        id: 'when-it-plays',
        title: 'When it plays',
        paragraphs: [
          'One moment, at the end of the action. Playing it on hover or on every keypress made the page feel nervous.',
        ],
      },
      {
        id: 'turning-it-off',
        title: 'Turning it off',
        paragraphs: [
          'It has to be easy to silence. A sound that you cannot refuse stops being a detail and becomes a demand.',
        ],
      },
    ]
  ),
  piece(
    'family-values',
    'Family Values',
    '2024-07-08',
    'The values were already in the house. The work was writing them down without sanding them flat.',
    [
      'I collected the phrases people actually use, then cut until each line could stand on a wall and still sound like someone in the family.',
    ],
    [
      {
        id: 'the-phrases',
        title: 'The phrases',
        paragraphs: [
          'I kept the wording that showed up more than once. A value nobody says out loud is a slogan, not a value.',
        ],
      },
      {
        id: 'how-they-sit',
        title: 'How they sit',
        paragraphs: [
          'Short lines, plenty of space, no decoration. The type has to feel like a note left on the counter, not a poster.',
        ],
      },
    ]
  ),
];

export const getPost = (slug) => posts.find((post) => post.slug === slug);
